import type Event from '../models/event';
import TicketType from '../models/ticket.type';

export function getPlaces(
  event: Event | string,
  ticketTypes: { place?: string }[]
) {
  const _place = typeof event === 'string' ? event : event?.place;
  if (!_place) return ['cargando...'];

  const places = ticketTypes
    .filter((x) => x.place)
    .map((x) => x?.place?.trim());

  if (!places.length) {
    places.push(_place);
  }

  return [...new Set(places)];
}
